import { useManagerContext } from "./context";
import { AutocompleteBase } from "./AutocompleteBase";

type AutocompleteSearchProps<O> = {
  filterKey: string;
  label: string;
  placeholder?: string;
  searchFn: (searchText: string, limit?: number) => Promise<O[]>;
  fetchByIdFn: (id: number) => Promise<O | null>;
  getOptionLabel: (option: O) => string;
  getOptionValue: (option: O) => number;
};

export function AutocompleteSearch<O>({
  filterKey,
  label,
  placeholder,
  searchFn,
  fetchByIdFn,
  getOptionLabel,
  getOptionValue,
}: AutocompleteSearchProps<O>) {
  const { searchParams, setFilter } = useManagerContext();
  const value = searchParams.filters?.[filterKey] as number | undefined;

  return (
    <AutocompleteBase<O>
      value={value}
      onChange={(v) => setFilter(filterKey, v)}
      label={label}
      labelWeight="medium"
      placeholder={placeholder}
      searchFn={searchFn}
      fetchByIdFn={fetchByIdFn}
      getOptionLabel={getOptionLabel}
      getOptionValue={getOptionValue}
    />
  );
}
